import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { stringMatchWithSearch } from '../../../../utils/globals/search'
import { CurrentPagePayload } from '../../../../utils/reducers/globals/currentPage'
import { Routes } from '../../../CreateRoutering/types'

export const getChildrenMenuItems = (menuItems: Routes, currentPage: CurrentPagePayload) => {
    for (const key in menuItems) {
        const item = menuItems[key]
        if (currentPage?.routes[0] === item.link) {
            return parseInt(key)
        }
    }
    return 0
}

export const getFilteredRoutes = (routes: Routes, searchValue: string): any[] => {
    const results: TwinDictionary = {}
    for (const baseRoute of routes) {
        if (baseRoute.childs?.length) {
            for (const section of baseRoute?.childs) {
                if (section?.childs?.length) {
                    for (const finalRoute of section?.childs) {
                        const finalTo = finalRoute.parsedLink || finalRoute.link
                        if (stringMatchWithSearch(searchValue, finalRoute?.text)) {
                            if (!results[baseRoute?.text]) {
                                results[baseRoute?.text] = {
                                    title: baseRoute?.text.toUpperCase(),
                                    displayItems: [],
                                    finalTo: baseRoute?.link
                                }
                            }
                            results[baseRoute?.text].displayItems.push({
                                parentText: section?.text,
                                displayText: finalRoute?.text,
                                searchText: finalRoute.text,
                                finalTo: finalRoute?.to || finalTo
                            })
                        }
                    }
                }
            }
        }
    }
    return Object.values(results)
}